import { all, takeEvery, put, call, fork } from 'redux-saga/effects'
import { normalize } from 'normalizr'

import { apiFetch } from '../../../helpers/restRequest'
import { deserialize } from '../../../helpers/jsonApi'
import actions from './actions'
import { staffSchema } from '../../schema'

const {
    STAFF_PROFILES_FETCH_REQUEST,
    STAFF_PROFILES_FETCH_SUCCESS,
    STAFF_PROFILES_SET_LOADING
} = actions

const staffProfilePath = '/staffs/me/profile'

export function *fetchCurrentStaffProfileRequest () {
    yield takeEvery(STAFF_PROFILES_FETCH_REQUEST, function *() {
        yield put({ type: STAFF_PROFILES_SET_LOADING, loading: true })

        try {
            const data = yield call(apiFetch, staffProfilePath)
            const deserializeData = deserialize(data)
            const normalizeData = normalize(deserializeData, staffSchema)

            yield put({ type: STAFF_PROFILES_FETCH_SUCCESS, ...normalizeData })
        } catch(error) {
            console.error('error:', error)
        } finally {
            yield put({ type: STAFF_PROFILES_SET_LOADING, loading: false })
        }
    })
}

export default function *rootSaga () {
    yield all([
        fork(fetchCurrentStaffProfileRequest)
    ])
}
